import React from 'react'
import moment from 'moment'
import FontAwesome from 'react-fontawesome'

Number.prototype.formatMoney = function (c, d, t) {
  var n = this,
    c = isNaN(c = Math.abs(c)) ? 2 : c,
    d = d == undefined ? "." : d,
    t = t == undefined ? "," : t,
    s = n < 0 ? "-" : "",
    i = parseInt(n = Math.abs(+n || 0).toFixed(c)) + "",
    j = (j = i.length) > 3 ? j % 3 : 0;
  return s + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "");
}

function formatValue(row, key) {
  // row: array of obj
  // key: obj key
  const val = row[key]
  if (isNaN(val) || val === '')
    return val
  if(typeof(val) == typeof(true)){
    return val
  }
  return parseFloat(val).formatMoney(2)
}

const momentHelper = {
  getMonth() {
    const monthNumber = new Date().getMonth() + 1
    return ('0000' + monthNumber).slice(-2)
  },
  getDay() {
    return parseInt(moment().format('DD'))
  },
  getMonthText(monthNumber) {
    return monthNumber !== '00' ? moment(monthNumber).format('MMMM') : 'ทั้งปี'
  },

  getYear() {
    return (new Date().getFullYear() * 1 + 543)
  },

  getThaiYear(date) {
    // date format: DD / MM / YYYY
    if (date.lastIndexOf("/") > date.length - 5) return ""
    return date.slice(date.lastIndexOf("/") + 1) * 1 + 543 + ""
  },

  getFullDate(date) {
    // moment.locale('th')
    const dayMonth = date.slice(0, date.lastIndexOf("/"))
    return moment(dayMonth).format('Do MMMM') + " " + this.getThaiYear(date)
  }
}

const tableHelper = {
  formatValue(row, key) {
    // row: array of obj
    // key: obj key
    const val = row[key]
    if (key.indexOf('Date') !== -1 && val.lastIndexOf("/") !== -1)
      return val.slice(0, val.lastIndexOf("/"))
        + "/"
        + momentHelper.getThaiYear(val).slice(2)
    if (isNaN(val) || val === '')
      return val
    if (typeof val === 'object')
      return val
    if(typeof(val) == typeof(true)){
      return val
    }
    return parseFloat(val).formatMoney(2)
  },

  renderHeader(titles) {
    const ths = titles.map((title, i) => (
      <th key={i} className='text-center'>{title}</th>
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  },

  renderRowHeader(item,i,onRenderCheckAll){
    let style1 = item.width!==undefined?{width:item.width}:{}
    let style2 = item.minWidth!==undefined?{minWidth:item.minWidth}:{}
    let style = Object.assign(style1,style2)
    let className = item.className!==undefined?item.className:''
  
    if (item.onClick!==undefined) {
      return(
        <th onClick={()=>{item.onClick(item.field,item.title)}} key={i} className={'text-center bg-blue-print '+className} style={style}>
          {item.title} {(item.sorting?<FontAwesome className='pull-right' name={(item.direction==='asc'?'sort-asc':item.direction==='desc'?'sort-desc':'sort')} />:'')}
        </th>
      )
    } else if (item.checkAll) {
      return onRenderCheckAll
    } else {
      return(
        <th key={i} className={'text-center bg-blue-print '+className} style={style}>
          {item.title}
        </th>
      )
    }  
    
  },

  renderHeaderCustom(headers,onRenderCheckAll) {
    const ths = headers.map((item, i) => (
      this.renderRowHeader(item,i,onRenderCheckAll)
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  },

  renderRowHeaderCustomJCBFilter(item,i,filter,mode,order_by,direction){
    let style1 = item.width!==undefined?{width:item.width}:{}
    let style2 = item.minWidth!==undefined?{minWidth:item.minWidth}:{}
    let style = Object.assign(style1,style2)
    let className = item.className!==undefined?item.className:''
    if (['work_no','car_registration_no','car_detail','customer_name','work_date','work_duration','appointment_date'].includes(item.field)) {
      style = Object.assign(style,{cursor:'pointer'})
      return(
        <th key={i} onClick={()=>{item.onClick(item.field,(direction==='asc'?'desc':'asc'))}}  className={'text-center bg-blue-print '+className} style={style}>
          <span>{item.title}{item.field===order_by?<FontAwesome className='pull-right' name={direction==='asc'?'sort-asc':direction==='desc'?'sort-desc':''} />:''}</span>
        </th>
      )
    } else {
      return(
        <th key={i} className={'text-center bg-blue-print '+className} style={style}>
          <span onClick={()=>{item.onClick(item.field,(filter[item.field]?false:true))}} className={(typeof filter[item.field]==='undefined'||mode==='print'?'':('btn btn-xs '+(filter[item.field]?'btn-success':'btn-default')))}>{(typeof filter[item.field]==='undefined'||mode==='print'?'':((filter[item.field]?<FontAwesome style={{marginRight:'2px'}} name='check-circle-o' />:'')))}{item.title}</span>
        </th>
      )
    }  
  },

  renderHeaderCustomJCBFilter(headers,filter,mode,order_by,direction) {
    const ths = headers.map((item, i) => (
      this.renderRowHeaderCustomJCBFilter(item,i,filter,mode,order_by,direction)
    ))

    return (
      <thead>
        <tr>
          {ths}
        </tr>
      </thead>
    )
  },

  onRowClick(onRowClick,index){
    onRowClick(index)
  },

  renderRowsCustom(rows,excludedColumns,excludeClickColumn,onRenderColumn,onRowClick){
    
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns !== undefined && excludedColumns.includes(key))
          return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key])||row[key]===''||row[key]===null ? "text-left" : key == "check" ? "text-center" : "text-right"
        if(excludeClickColumn!==undefined && excludeClickColumn.includes(key)){
          return <td className={tdClass} key={kid + 1} >{onRenderColumn(formattedValue,kid,row,index)}</td>
        }else{
          return <td className={tdClass} key={kid + 1} onClick={()=>{onRowClick(index)}}>{onRenderColumn(formattedValue,kid,row,index)}</td>
        }
      })

      return <tr key={index} >{tds}</tr>
    })
  },

  renderRows(rows, excludedColumns,onRowClick) {
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns !== undefined && excludedColumns.includes(key))
          return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        
        return <td className={tdClass} key={kid + 1}>{formattedValue}</td>
      })

      return <tr key={index} onClick={this.onRowClick.bind(this,onRowClick,index)}>{tds}</tr>
    })
  },

  renderRowsWithIds(rows, excludedColumns) {
    return rows.map((row, index) => {
      // create an array of <td>
      const tds = Object.keys(row).map((key, kid) => {
        if (excludedColumns.includes(key)) return

        const formattedValue = this.formatValue(row, key)
        const tdClass = isNaN(row[key]) ? "text-left" : "text-right"
        return <td className={tdClass} key={kid + 1}>{formattedValue}</td>
      })

      // add id column to array of <td>
      const tdWithIds = [<td key={0} className="text-center" >{index + 1}</td>].concat(tds)
      return <tr key={index}>{tdWithIds}</tr>
    })
  }

}

export { momentHelper, tableHelper }



// WEBPACK FOOTER //
// ./src/view/report/helpers.js